import type { AccountTab } from './utils/accountRedirect';

export interface OfferEligibility {
  eligible: boolean;
  issues: string[];
  listingCount: number;
}

export const OFFER_ISSUE = {
  NotVerified: 'NotVerified',
  ContactIncomplete: 'ContactIncomplete',
  StripeNotSetUp: 'StripeNotSetUp',
  SelfBillingNotAccepted: 'SelfBillingNotAccepted',
  BusinessSeller: 'BusinessSeller',
} as const;

type Translate = (key: string, params?: Record<string, string | number>) => string;

const ISSUE_TRANSLATION_KEYS: Record<string, string> = {
  [OFFER_ISSUE.NotVerified]: 'offer_eligibility.issue_not_verified',
  [OFFER_ISSUE.ContactIncomplete]: 'offer_eligibility.issue_contact_incomplete',
  [OFFER_ISSUE.StripeNotSetUp]: 'offer_eligibility.issue_stripe_not_set_up',
  [OFFER_ISSUE.SelfBillingNotAccepted]: 'offer_eligibility.issue_self_billing_not_accepted',
  [OFFER_ISSUE.BusinessSeller]: 'offer_eligibility.issue_business_seller',
};

export function translateOfferIssues(issues: string[], t: Translate): string[] {
  return issues.map(issue => t(ISSUE_TRANSLATION_KEYS[issue] ?? issue));
}

export function formatOfferEligibilityBannerMessage(issues: string[], t: Translate): string {
  const translated = translateOfferIssues(issues, t);
  if (translated.length === 0) return '';
  return t('offer_eligibility.banner_intro', { issues: translated.join('; ') });
}

export function shouldShowOfferEligibilityBanner(eligibility: OfferEligibility | null): boolean {
  return eligibility != null && !eligibility.eligible && eligibility.listingCount > 0;
}

const OWNER_TAB_ISSUES: string[] = [
  OFFER_ISSUE.ContactIncomplete,
  OFFER_ISSUE.StripeNotSetUp,
  OFFER_ISSUE.SelfBillingNotAccepted,
];

/** Which account tab resolves these issues; only NotVerified lives outside the lender tab. */
export function accountTabForOfferIssues(issues: string[]): AccountTab {
  return issues.some(issue => OWNER_TAB_ISSUES.includes(issue)) ? 'owner' : 'settings';
}
